import { createJSONStorage } from 'zustand/middleware';
import { createThemeStore, ThemeMode } from '@fretgenius/ui/theme';
import { reportError } from '@/utils/errorReporting';

/**
 * Web-specific implementation of the theme store
 * Uses Zustand with localStorage persistence and system preference detection
 */

// Function to check the system preference
const getSystemThemePreference = (): ThemeMode => {
  // Check for system preference when no saved theme exists
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return ThemeMode.Dark;
  }
  return ThemeMode.Light;
};

// Create the store instance for the web app
export const useThemeStore = createThemeStore({
  storage: createJSONStorage(() => localStorage),
  getInitialMode: getSystemThemePreference,
  reportErrorFn: reportError, // Provide the centralized reporter
});
